import db from "../db/database";

// Inicializar la tabla de entorno si no existe
export const initializeEnvironmentTable = async () => {
    try {
        // Verificar si la tabla existe y tiene datos
        const count = await db.environment.count();
        if (count === 0) {
            // Crear configuración por defecto
            const defaultEnv = {
                company: "Santillana Ecuador",
                env: "Santillana_Ecuador",
                apiUrl: "https://usuarios-api.app.elingenierojefe.es",
                bcBaseUrl: "https://api.businesscentral.dynamics.com/v2.0/7516bb18-282c-4e63-b1ec-795805f1e8fd",
                grant_type: "client_credentials",
                client_secret: "ljO8Q~p4Ka8k3omAJc5cRUhSzhXR2hdOYg2kWcYu",
                client_id: "c6ecdbe2-1087-407d-9a0d-adf671cc102d",
                scope: "https://api.businesscentral.dynamics.com/.default",
                loginUrl: "https://login.microsoftonline.com/7516bb18-282c-4e63-b1ec-795805f1e8fd/oauth2/v2.0/token",
                isActive: true,
                lastModified: new Date(),
            };

            await db.environment.add(defaultEnv);
            console.log("Configuración de entorno por defecto creada");
        }
    } catch (error) {
        console.error("Error inicializando tabla de entorno:", error);
    }
};

// Obtener la configuración activa del entorno
export const getActiveEnvironment = async () => {
    try {
        // Asegurar que la tabla esté inicializada
        await initializeEnvironmentTable();

        // Obtener todas las configuraciones y filtrar la activa
        const allEnvs = await db.environment.toArray();
        const activeEnv = allEnvs.find(env => env.isActive === true);

        if (!activeEnv) {
            throw new Error("No se encontró configuración de entorno activa");
        }

        return activeEnv;
    } catch (error) {
        console.error("Error al obtener configuración de entorno:", error);
        throw error;
    }
};

// Guardar nueva configuración de entorno
export const saveEnvironment = async (environmentData) => {
    try {
        console.log("Iniciando guardado de configuración de entorno:", environmentData);

        // Asegurar que la tabla esté inicializada
        await initializeEnvironmentTable();

        // Desactivar todas las configuraciones existentes
        const allEnvs = await db.environment.toArray();
        console.log("Configuraciones existentes:", allEnvs.length);

        for (const env of allEnvs) {
            if (env.isActive) {
                console.log("Desactivando configuración:", env.id);
                await db.environment.update(env.id, { isActive: false });
            }
        }

        // Añadir la nueva configuración como activa
        const newEnv = {
            ...environmentData,
            isActive: true,
            lastModified: new Date(),
        };

        console.log("Guardando nueva configuración:", newEnv);
        const id = await db.environment.add(newEnv);
        console.log("Configuración guardada con ID:", id);

        return { ...newEnv, id };
    } catch (error) {
        console.error("Error al guardar configuración de entorno:", error);
        console.error("Stack trace:", error.stack);
        throw error;
    }
};

// Limpiar toda la base de datos excepto la configuración de entorno
export const clearDatabaseData = async () => {
    try {
        console.log("Iniciando limpieza de base de datos...");

        // Lista de todas las tablas a limpiar (excluyendo environment)
        const tablesToClear = [
            "users",
            "clients",
            "products",
            "invoices",
            "invoiceLines",
            "invoicePaymentLines",
            "productLines",
            "formasPago",
            "turnos",
            "aperturaDeCaja",
            "cajas",
            "cierreDeCaja",
            "cierreDeCajaDetalle",
            "formaDePago",
            "divisas",
            "colegios",
            "tpvs",
            "coupons",
            "couponSalesPrices",
            "couponLineDiscounts",
            "couponDetails",
            "salesPrices",
        ];

        // Limpiar cada tabla
        for (const tableName of tablesToClear) {
            await db[tableName].clear();
            console.log(`Tabla ${tableName} limpiada`);
        }

        // Reañadir divisas predeterminadas
        await db.divisas.bulkAdd([
            {
                CodDivisa: "EUR",
                Descripcion: "Euro",
                Simbolo: "€",
                pendingSync: false,
                deleted: false,
            },
            {
                CodDivisa: "USD",
                Descripcion: "Dólar estadounidense",
                Simbolo: "$",
                pendingSync: false,
                deleted: false,
            },
            {
                CodDivisa: "BS",
                Descripcion: "Bolívar",
                Simbolo: "Bs.",
                pendingSync: false,
                deleted: false,
            },
        ]);

        console.log("Limpieza de base de datos completada");
        return true;
    } catch (error) {
        console.error("Error al limpiar base de datos:", error);
        throw error;
    }
};

// Validar configuración de entorno
export const validateEnvironment = (environmentData) => {
    const requiredFields = [
        "company",
        "env",
        "apiUrl",
        "bcBaseUrl",
        "client_secret",
        "client_id",
        "scope",
        "loginUrl",
    ];

    for (const field of requiredFields) {
        if (!environmentData[field] || environmentData[field].trim() === "") {
            throw new Error(`El campo ${field} es obligatorio`);
        }
    }

    // Validar URLs
    const urlFields = ["apiUrl", "bcBaseUrl", "loginUrl"];
    for (const field of urlFields) {
        try {
            new URL(environmentData[field]);
        } catch {
            throw new Error(`El campo ${field} debe ser una URL válida`);
        }
    }

    return true;
};

// Obtener todas las configuraciones de entorno
export const getAllEnvironments = async () => {
    try {
        // Asegurar que la tabla esté inicializada
        await initializeEnvironmentTable();

        const allEnvs = await db.environment.toArray();
        return allEnvs.sort((a, b) => new Date(b.lastModified) - new Date(a.lastModified));
    } catch (error) {
        console.error("Error al obtener configuraciones de entorno:", error);
        throw error;
    }
};

// Eliminar configuración de entorno
export const deleteEnvironment = async (id) => {
    try {
        const env = await db.environment.get(id);
        if (env && env.isActive) {
            throw new Error("No se puede eliminar la configuración activa");
        }
        await db.environment.delete(id);
        return true;
    } catch (error) {
        console.error("Error al eliminar configuración de entorno:", error);
        throw error;
    }
}; 